import styled from 'styled-components'
import { Dropdown } from 'react-bootstrap'

export const Menu = styled(Dropdown.Menu)`
  width: 20rem;
  padding: 0.25rem 0;
  background-color: ${props => props.theme.colors.backgroundDropdown};
`
